(function () {
  'use strict';

  var pending = new Set();
  var observer;
  var framePending = false;
  var motionQuery = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var touchQuery = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)');

  function canAnimate() {
    return !(motionQuery && motionQuery.matches) && !(touchQuery && touchQuery.matches);
  }

  function reveal(element, animate) {
    element.style.visibility = 'visible';
    element.classList.remove('merlons-reveal-pending');
    element.classList.add('ewow');
    if (animate) {
      element.classList.add('animated');
    } else {
      element.classList.remove('animated');
      element.classList.add('merlons-reveal-static');
    }
    element.dataset.merlonsRevealed = 'true';
    pending.delete(element);
    if (observer) observer.unobserve(element);
  }

  function isNearViewport(element) {
    var rect = element.getBoundingClientRect();
    return rect.bottom >= -80 && rect.top <= window.innerHeight + 80;
  }

  // Cover restored pages and delayed observer callbacks in embedded browsers.
  // Work stops as soon as every item has been shown.
  function checkViewport() {
    framePending = false;
    pending.forEach(function (element) {
      if (!canAnimate() || isNearViewport(element)) reveal(element, canAnimate());
    });
  }

  function scheduleCheck() {
    if (framePending || !pending.size) return;
    framePending = true;
    window.requestAnimationFrame(checkViewport);
  }

  function init(scope) {
    scope = scope && scope.querySelectorAll ? scope : document;
    var elements = Array.from(scope.querySelectorAll('.wow'));
    if (scope.matches && scope.matches('.wow')) elements.unshift(scope);
    elements = elements.filter(function (element) {
      return element.dataset.merlonsRevealed !== 'true' && !pending.has(element);
    });
    if (!elements.length) return;

    if (!canAnimate() || typeof window.IntersectionObserver !== 'function') {
      elements.forEach(function (element) { reveal(element, false); });
      return;
    }

    try {
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) reveal(entry.target, canAnimate());
          });
        }, { rootMargin: '80px 0px', threshold: 0.01 });
      }
      elements.forEach(function (element) {
        if (isNearViewport(element)) {
          reveal(element, true);
        } else {
          // Only a working observer on a motion-capable device may hide content.
          observer.observe(element);
          pending.add(element);
          element.classList.add('merlons-reveal-pending');
        }
      });
    } catch (error) {
      elements.forEach(function (element) { reveal(element, false); });
      pending.forEach(function (element) { reveal(element, false); });
      if (observer) observer.disconnect();
      observer = null;
    }
  }

  function motionChanged() {
    if (!canAnimate()) {
      pending.forEach(function (element) { reveal(element, false); });
      document.querySelectorAll('.wow').forEach(function (element) { reveal(element, false); });
    }
  }

  [motionQuery, touchQuery].forEach(function (query) {
    if (!query) return;
    if (query.addEventListener) query.addEventListener('change', motionChanged);
    else if (query.addListener) query.addListener(motionChanged);
  });
  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck, { passive: true });
  window.addEventListener('pageshow', scheduleCheck);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    pending.forEach(function (element) {
      if (event.target.contains(element)) {
        if (observer) observer.unobserve(element);
        pending.delete(element);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();
